import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";

import PageLayout from "@/components/layout/PageLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

import Login from "@/pages/Login";
import CommandCenter from "@/pages/CommandCenter";
import FleetMonitor from "@/pages/FleetMonitor";
import EngineAnalytics from "@/pages/EngineAnalytics";
import FuelEnergy from "@/pages/FuelEnergy";
import Geolocation from "@/pages/Geolocation";
import ServiceHub from "@/pages/ServiceHub";
import SalesCRM from "@/pages/SalesCRM";
import AIAssistant from "@/pages/AIAssistant";
import DataImport from "@/pages/DataImport";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import DumperIntelligence from "@/pages/DumperIntelligence";

const wrap = (Page) => (
  <ErrorBoundary>
    <Page />
  </ErrorBoundary>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <PageLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<ProtectedRoute>{wrap(CommandCenter)}</ProtectedRoute>} />
              <Route path="fleet" element={<ProtectedRoute>{wrap(FleetMonitor)}</ProtectedRoute>} />
              <Route path="engine" element={<ProtectedRoute>{wrap(EngineAnalytics)}</ProtectedRoute>} />
              <Route path="fuel" element={<ProtectedRoute>{wrap(FuelEnergy)}</ProtectedRoute>} />
              <Route path="geo" element={<ProtectedRoute>{wrap(Geolocation)}</ProtectedRoute>} />
              <Route path="service" element={<ProtectedRoute>{wrap(ServiceHub)}</ProtectedRoute>} />
              <Route path="sales" element={<ProtectedRoute>{wrap(SalesCRM)}</ProtectedRoute>} />
              <Route path="dumper" element={<ProtectedRoute>{wrap(DumperIntelligence)}</ProtectedRoute>} />
              <Route path="ai" element={<ProtectedRoute>{wrap(AIAssistant)}</ProtectedRoute>} />
              <Route path="import" element={<ProtectedRoute>{wrap(DataImport)}</ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute>{wrap(Reports)}</ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute>{wrap(Settings)}</ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
